export default __webpack_public_path__ + "static/cointelegraph-f9fac0368edbded7393218a807e5da3c.png";